<template>
    <div>
      <BaseFrame
        clearText=""
        :recipePassText= "handlePermission('recipePass') && recipeData.medicalRx.status == 1 ? '审核通过' : ''"
        @passRecipeClick="passModal = true;"
        :printText= "handlePermission('recipeRecall') && recipeData.medicalRx.status == 1  ? '审核驳回' : ''"
        @print="refuseModal = true"
        >
        <div class="container" slot="content">
          <recipeInfo :info="recipeData.medicalRx"></recipeInfo>
          <div class="tableContent">
            <lk-card title="处方药品明细">
              <lk-table border :columns='recipeColumns' :data='recipeData.medicalRxDetailList'></lk-table>
            </lk-card>
          </div>
          <!-- <div class="tableContent">
            <lk-card title="处方原件">
              <a v-bind:href="recipeData.medicalRx.rxPic" target="_blank">下载处方</a>
            </lk-card>
          </div> -->
          <div></div>
          <lk-modal title="处方审核" v-model="passModal" :footer-hide='true' width="400">
            <div style="display:flex; margin-left: 10px;">
                <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
                <h6 style="margin-top: 6px;">是否确认处方审核通过？</h6>
            </div>
            <div class="bottomButton">
                <lk-button type='primary' @click="checkDrug">确认</lk-button>
                <lk-button @click="passModal = false;">取消</lk-button>
            </div>
          </lk-modal>
          <lk-modal title="处方审核" v-model="refuseModal" :footer-hide='true' width="400">
            <div style="display:flex; margin-left: 10px;">
                <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
                <h6 style="margin-top: 6px;font-size: 12px;">是否确认处方审核驳回？</h6>
            </div>
            <div style="display:flex">
              <span style="color: red;margin-top:6px;margin-left: 15px;margin-right: 3px; font-size: 18px;">*</span>
              <span style="margin-top:8px; font-size: 12px;">驳回原因：</span>
            </div>
            <lk-input style="margin-left:22px; margin-right: 20px; width: 340px; margin-top: 0px;" placeholder='请输入驳回原因' :maxlength="200" clearable v-model.trim="refuseReason" type="textarea"></lk-input>
            <div class="bottomButton">
                <lk-button type='primary' :disabled="refuseReason == ''" @click="refuseRecipeClick">确认</lk-button>
                <lk-button @click="refuseModal = false; refuseReason=''; refuseModal=false">取消</lk-button>
            </div>
          </lk-modal>
          <lk-modal title="处方审核" v-model="showReadingModal" :footer-hide='true' :mask-closable='false' :closable='false' width="400">
            <div>
                <span class="blueIcon iconfont" style="margin-left: 160px;">&#xe613;</span> &nbsp;
                <div style="margin-top: 6px; margin-left: 100px">请扫描药师审方电子凭证二维码</div>
            </div>
          </lk-modal>
          <lk-modal title="提示" v-model="errorModal" :footer-hide='true' width="400">
            <div style="display:flex; margin-left: 10px;">
                <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
                <h6 style="margin-top: 6px;"> 处方中商品 {{errorStr}} 没有维护医保对码，无法自动引用至销售订单，是否确认流转处方?</h6>
            </div>
            <div class="bottomButton">
                <lk-button type='primary' @click="passRecipeClick">确认</lk-button>
                <lk-button @click="errorModal = false;">取消</lk-button>
            </div>
          </lk-modal>
          <!-- 验签弹框 -->
          <lk-modal title="电子处方验签结果" v-model="showCheckTagModal" :footer-hide='true' width="400">
            <div style="display:flex; margin-left: 10px;">
                <span class="dotClass" :style="{background: checkStatus ? 'blue' : 'red'}"></span> &nbsp;
                <h6 style="margin-top: 6px;font-size: 12px;">{{ checkStatus ? "电子处方验签成功" : '电子处方验签失败，不支持创建医保订单' }}</h6>
            </div>
            <div style="margin-top:15px; font-size: 12px; margin-left: 40px; width: 320px;">
              <div style="word-break: break-all;">验签流水号：{{tagNo}}</div>
              <div style="margin-top:15px; margin-right: 10px; word-break: break-all;">签名机构证书SN：{{tagSN}}</div>
              <div style="margin-top:15px; word-break: break-all;">签名机构证书DN：{{tagDN}}</div>
            </div>
            <div class="bottomButton">
                <lk-button style="margin-left: 85px;" @click="showCheckTagModal = false; $router.go(-1);">关闭</lk-button>
            </div>
          </lk-modal>
        </div>
      </BaseFrame>
      <div class="image-container">
        <!-- <pdf style="width: 450px; height: 726px;" :src="recipeData.medicalRx.rxPic"></pdf> -->
        <!-- https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf -->
        <pdf style="width: 450px; height: 628px;" :src="recipeData.medicalRx.rxPic"></pdf>
      </div>
    </div>
  </template>
<script>

import Axios from 'axios';
// import * as pdfjs from 'pdfjs-dist';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

import pdf from 'vue-pdf';
import BaseFrame from '../../components/frame/BaseFrame.vue';
import utils from '../../libs/utils';
import recipeInfo from './recipeInfo.vue';
import recipePatient from './recipePatientInfo.vue';
import queryMixins from '../../mixins/queryMixins';
import healthInsManage from '../../services/healthInsManage';

export default {
  name: 'recipeDetail',
  mixins: [queryMixins],
  components: {
    BaseFrame,
    recipeInfo,
    recipePatient,
    pdf,
  },

  computed: {
    editCode() {
      return '审核驳回';
    },
    needReadCard() {
      return [25, 29, 62].indexOf(this.$store.state.storeInfo.id) >= 0; // TODO:LZL 上线修改兰州 测试109 线上29：兰州, 25：哈尔滨 62:深圳
    },
  },
  data() {
    return {
      showReadingModal: false,
      refuseReason: '',
      passModal: false,
      refuseModal: false,
      checkStatus: false,
      showCheckTagModal: false,
      tagNo: '', // 验签流水号
      tagSN: '', // 机构证书
      tagDN: '', // 机构dn
      recipeData: {
        medicalRx: {
          rxNo: '',
          fixmedinsName: '',
          prscDeptName: '',
          prscTime: '',
          rxTypeName: '',
          maindiagName: '',
          diseCondDscr: '',
          diseCodg: '',
          diseName: '',
          patnName: '',
          patnAge: '',
          gend: 1,
          algsHis: '',
          status: 1,
        },
      },
      recipeList: [],
      recipeColumns: [
        {
          title: '医疗目录编码', key: 'medListCodg', width: 130,
        },
        { title: '药品通用名', key: 'drugGenname', minWidth: 116 },
        { title: '药品剂型', key: 'drugDosform', minWidth: 116 },
        { title: '药品规格', key: 'drugSpec', minWidth: 116 },
        { title: '药品编码', key: 'serialCode', minWidth: 116 },
        { title: '用药途径描述', key: 'medcWayDscr', minWidth: 116 },
        { title: '频次', key: 'usedFrquName', minWidth: 116 },
        {
          title: '单次用药量',
          key: 'medcWayDscr',
          minWidth: 116,
          render: (h, params) => h('span', params.row.sinDoscnt + params.row.sinDosunt),
        },
        {
          title: '用药开始时间',
          key: 'medcBegntime',
          minWidth: 116,
          render: (h, params) => h('span', utils.formatDate(params.row.medcBegntime)),
        },
        {
          title: '用药结束时间',
          key: 'medcEndtime',
          minWidth: 116,
          render: (h, params) => h('span', utils.formatDate(params.row.medcEndtime)),
        },
        { title: '用药天数', key: 'medcDays', minWidth: 116 },
        { title: '总用药量', key: 'drugTotlcnt', minWidth: 116 },
        { title: '单位', key: 'drugTotlcntEmp', minWidth: 116 },
      ],
      errorStr: '',
      errorModal: false,
    };
  },
  methods: {
    checkDrug() {
      const errList = [];
      this.recipeList.forEach((item) => {
        if (!item.serialCode || item.serialCode == undefined || item.serialCode == '') {
          errList.push(item.drugGenname);
        }
      });
      if (errList.length > 0) {
        this.errorStr = errList.join('、');
        this.passModal = false;
        this.errorModal = true;
      } else {
        this.passRecipeClick();
      }
    },
    passRecipeClick() {
      if (this.needReadCard) {
        this.errorModal = false;
        this.showReadingModal = true;
        this.passModal = false;
        this.readCard(true);
      } else {
        this.rxAudit({ rxId: this.$route.params.id, status: 2 }, true);
      }
    },
    rxAudit(params, isPass) {
      healthInsManage.rxAudit(params).then((res) => {
        if (res.data.status === 200) {
          if (Object.keys(res.data.data).indexOf('rxInfoVerifyFlag') >= 0) {
            this.checkStatus = res.data.data.rxInfoVerifyFlag;
            this.tagNo = res.data.data.rxSignVerifySn;
            this.tagSN = res.data.data.signCertSn;
            this.tagDN = res.data.data.signCertDn;
            this.showCheckTagModal = true;
          } else {
            this.$Message.success(isPass ? '审核已通过' : '审核已驳回');
            this.$router.go(-1);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    refuseRecipeClick() {
      if (this.needReadCard) {
        this.showReadingModal = true;
        this.refuseModal = false;
        this.readCard(false);
      } else {
        const refuseParams = {
          rxId: this.$route.params.id,
          status: 6,
          authRemark: this.refuseReason,
        };
        this.handleRefuseClick(refuseParams);
      }
    },
    handleRefuseClick(params) {
      this.rxAudit(params, false);
    },
    getData() {
      healthInsManage.recipeDetail({ id: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.recipeData = res.data.data;
          if (this.recipeData.medicalRx.rxPic) {
            if (!this.recipeData.medicalRx.rxPic.includes('https')) {
              this.recipeData.medicalRx.rxPic = this.recipeData.medicalRx.rxPic.replace('http', 'https');
            }
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    readCard(isPass) {
      const obj = {
        type: 1, // 固定： 1 电子医保卡
        personType: 1, // 大陆： 1
        operate: 1,
        medicalSubject: 0, // 市医保： 1
      };
      healthInsManage.readCard(obj).then((res) => {
        this.showReadingModal = false;
        if (res.data.status === 200) {
          const {
            psnCertType,
            psnName,
            certno,
            mdtrt_cert_no,
          } = res.data.data || {};
          if (isPass) {
            const params = {
              psnCertType,
              psnName,
              certno,
              mdtrt_cert_no,
              rxId: this.$route.params.id,
              status: 2,
            };
            this.rxAudit(params, true);
          } else {
            const refuseParams = {
              psnCertType,
              psnName,
              certno,
              mdtrt_cert_no,
              rxId: this.$route.params.id,
              status: 6,
              authRemark: this.refuseReason,
            };
            this.handleRefuseClick(refuseParams);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.showReadingModal = false;
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.params.type) {
      if (this.handlePermission('recipePass')) {
        to.meta.subTitle = '处方审核';
      } else {
        to.meta.subTitle = '查看';
      }
    }
    next();
  },
};

</script>
<style lang="less" scoped>
.tableContent {
    padding-top: 20px;
}
.bottomButton{
    margin-left: 223px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}
.warnIcon {
  color: orange;
  font-size: 20px;
};
.blueIcon {
  color: cornflowerblue;
  font-size: 40px;
};
.bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
  }
  .image-container {
  position: absolute;
  left: 800px;
  top: 160px;
  width: 40%;
  height: 400px;
  }

.dotClass {
  width:15px;
  height:15px;
  border-radius: 50%;
  display: block;
  margin-left: 10px;
  margin-top: 5px;
}
</style>
